module.exports = __webpack_public_path__ + "img/image-sign.06cc6246.png";